import { DialogErrorHeader } from "@ext/errorHandlers/client/components/DialogErrorHeader";
import type { GetErrorComponentProps } from "@ext/errorHandlers/logic/GetErrorComponent";
import type { PushDeclinedByRemoteData } from "@ext/git/core/GitCommands/errors/LibGit2Error";
import t from "@ext/localization/locale/translate";
import CodeBlock from "@ext/markdown/elements/codeBlockLowlight/render/component/CodeBlock";
import { DialogBody, DialogFooterTemplate } from "@ui-kit/Dialog";
import { IconTooltip } from "@ui-kit/IconTooltip";

/**
 * A server-side hook refused the push (protected branch, push rules, custom pre-receive).
 * Shows the plain explanation, the libgit2 status line behind a "?" tooltip,
 * and the server's own message as a code block — no stacktrace.
 */
const PushDeclinedByRemoteErrorComponent = ({ error, onCancelClick }: GetErrorComponentProps) => {
	const data = error.props?.errorData as PushDeclinedByRemoteData | undefined;

	return (
		<>
			<DialogErrorHeader error={error} />
			<DialogBody>
				<div className="article" style={{ background: "transparent" }}>
					<p className="inline-flex items-center gap-1">
						<span>{t("git.publish.error.declined.body")}</span>
						{data?.status && <IconTooltip content={data.status} icon="circle-help" iconSize="sm" />}
					</p>
					{data?.remoteMessage ? (
						<>
							<p>{t("git.publish.error.declined.remote-message")}</p>
							<CodeBlock withoutHighlight>{data.remoteMessage}</CodeBlock>
						</>
					) : (
						<p>{t("git.publish.error.declined.no-reason")}</p>
					)}
				</div>
			</DialogBody>
			<DialogFooterTemplate primaryButton={t("ok")} primaryButtonProps={{ onClick: onCancelClick }} />
		</>
	);
};

export default PushDeclinedByRemoteErrorComponent;
